export const handleErrors = (payload) => {
    let message = 'Whoops! Something went wrong. :(';

    if (payload.data && payload.data.errors)
    {
        Object.entries(payload.data.errors).forEach(([, error]) => ([message] = error));
    }
    else if (payload && payload.message) {
        message = payload.message;
    }

    return message;
};

export const formatDate = theDate => {
    const nth = function(d) {
        if (d > 3 && d < 21) return 'th';
        switch (d % 10) {
            case 1:  return "st";
            case 2:  return "nd";
            case 3:  return "rd";
            default: return "th";
        }
    };
    const newDate = new Date(theDate);
    const date = newDate.getDate();
    const day = date + nth(date);
    const month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][newDate.getMonth()];
    const year = newDate.getFullYear();

    return `${day} ${month}, ${year}`
}

export const formatDateTime = (value) => {
    if (value === null || value === undefined || value === '') {
        return '—';
    }

    const text = String(value).trim();
    const wallClock = text.match(/^(\d{4}-\d{2}-\d{2})[ T](\d{2}):(\d{2})/);
    const hasZone = /(?:[zZ]|[+-]\d{2}:?\d{2})$/.test(text);

    if (wallClock && !hasZone) {
        return `${wallClock[1]} ${wallClock[2]}:${wallClock[3]}`;
    }

    const date = new Date(text);

    if (Number.isNaN(date.getTime())) {
        return text;
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}`;
}

export const formatExpiryDateTime = (value) => formatDateTime(value);
